import configs from 'config';
import store from 'redux/store';
import cleverTapConstant from 'constants/cleverTapConstant';
import { nativeHandler } from './';
import getAppInfo from './getAppInfo';
export const CleverTapEventNames = cleverTapConstant;
export const CleverTapEvent = {
	// send events to clever track
	send: function (eventName = '', eventParams = []) {
		let finalEventParams = {};
		// format event Name
		// format property values to lowercase and replace space into _ (eg. Event Value to event_value)
		try {
			if (typeof eventName === 'string') {
				eventName = `${eventName.replace(/ /g, '_')}`;
			}
		} catch (e) {
			console.error('Error on converting CleverTap eventName');
		} finally {
			eventName = `${configs.projectName}|${eventName}`;
		}

		// format property values to lowercase and replace space into _ (eg. Event Value to event_value)
		try {
			if (typeof eventParams === 'string' && eventParams) {
				eventName = `${eventName}|${eventParams.replace(/ /g, '_')}`;
				// finalEventParams["context"] = `${titleCase(eventParams, " ").replace(
				//   / /g,
				//   "_"
				// )}`;
			} else {
				for (let index = 0; index < eventParams.length; index++) {
					const element = eventParams[index];
					if (typeof element === 'string') {
						if (element.includes(':')) {
							const key = element.split(': ')[0];
							const value = element.split(': ')[1];
							finalEventParams[key] = `${value.replace(/ /g, '_')}`;
						} else {
							if (element) eventName = `${eventName}|${element.replace(/ /g, '_')}`;
							// finalEventParams["context"] = `${titleCase(element, " ").replace(
							//   / /g,
							//   "_"
							// )}`;
						}
					}
				}
			}
		} catch (e) {
			console.error('Error on converting CleverTap params values');
		}
		finalEventParams['mobile'] = store?.getState()?.homeDetails?.mobileNumber;
		finalEventParams['latitude'] = getAppInfo()?.latitude || '';
		finalEventParams['longitude'] = getAppInfo()?.longitude || '';
		finalEventParams['marketing_event'] = 'yes';
		let isMandatoryEvent = false;
		const rawEventName = eventName.split('|');
		Object.values(cleverTapConstant.EVENTS_NAME.MANDATORY_EVENTS).map((item) => {
			if (item.replace(/ /g, '_') === rawEventName?.[1]) {
				isMandatoryEvent = true;
				return;
			}
		});
		if (isMandatoryEvent) {
			finalEventParams = {
				...finalEventParams,
				...(finalEventParams['af_revenue'] && {
					af_currency: 'INR',
				}),
			};
			eventName = eventName.replace('|page_landing', '');
		} else {
			finalEventParams = {
				...finalEventParams,
				...(rawEventName?.[1] && {
					screen: rawEventName?.[3] ? rawEventName?.[2] : rawEventName?.[1],
				}),
				...(rawEventName?.[2] &&
					(rawEventName?.[2] === 'page_landing'
						? {
								action: 'loaded',
						  }
						: {
								module: rawEventName?.[3] ? rawEventName?.[1] : rawEventName?.[2],
								action: rawEventName?.[3] || 'click',
						  })),
				...(finalEventParams['af_revenue'] && {
					af_currency: 'INR',
				}),
			};
			eventName = rawEventName?.[1];
		}
		console.log('eventName', eventName);
		console.log('eventParams', finalEventParams);
		nativeHandler.sendCleverTapEvent(eventName, finalEventParams);
	},
};
